// Combined media banner for Searchanise results pages
// Prefers snizeImageUrl; if empty, uses snizeVideoUrl.

document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {
    $(document).on('Searchanise.ResultsUpdated', function () {

      // ---- PAGE EXCLUSIONS ----
      // Add collection handles here that should NOT show the banner.
      // Example: /collections/jeanas-winter-mvps → 'jeanas-winter-mvps'
      const excludedCollectionHandles = [
        'face-reality',
        'shop-all-black-friday-cyber-monday-deals',
        'concern-loss-of-firmness'
      ];

      const path = window.location.pathname; // e.g. "/collections/jeanas-winter-mvps"

      if (path.startsWith('/collections/')) {
        const parts = path.split('/'); // ["", "collections", "handle", ...]
        const handle = parts[2] || '';
        if (excludedCollectionHandles.includes(handle)) {
          return; // stop here; don't inject the banner
        }
      }
      // ------------------------

      // ---- SETTINGS ----
      let snizeImageUrl       = 'https://cdn.shopify.com/s/files/1/0598/8024/3273/files/LossofFirmness-WebBanners-SearchBanner_1.jpg?v=1772463925'; // '' to disable https://cdn.shopify.com/s/files/1/0598/8024/3273/files/GlowList-11.10-11.20-03-SearchBanner_1.jpg?v=1762788320
      let snizeVideoUrl       = '';                                     // '' to disable https://cdn.shopify.com/videos/c/o/v/059b73aa57c840dc8e164fdb1c9e46a1.mp4
      let snizeRedirectUrl    = 'https://artofskincare.com/collections/concern-loss-of-firmness';
      let snizeBannerPosition = 3; // 1-based index; place before this item
      // -------------------

      // Ensure we’re on a Searchanise-rendered results page (grid or list mode)
      const $resultsList =
        $('ul.snize-search-results-content').first(); // primary container on Searchanise pages

      if ($resultsList.length === 0) return; // nothing to inject into

      // Avoid duplicate injects on subsequent ResultsUpdated events
      if ($resultsList.find('.snize-custom-banner').length) return;

      const hasImage = !!snizeImageUrl && snizeImageUrl.trim() !== '';
      const hasVideo = !!snizeVideoUrl && snizeVideoUrl.trim() !== '';
      if (!hasImage && !hasVideo) return;

      // Build media HTML
      const mediaHtml = hasImage
        ? `<img src="${snizeImageUrl}" alt="">`
        : `<video width="100%" height="auto" autoplay muted loop playsinline>
             <source src="${snizeVideoUrl}" type="video/mp4">
           </video>`;

      // Compute insertion point safely (append if list shorter than position)
      const $items = $resultsList.children('li');
      const index  = Math.max(1, parseInt(snizeBannerPosition, 10) || 1);
      const $beforeNode = $items.eq(index - 1); // nth-child(N)

      const bannerHtml = `
        <li class="snize-banner snize-custom-banner" style="min-width:auto; width:31.3%;">
          <a href="${snizeRedirectUrl}" target="_self" aria-label="Promotional banner">
            ${mediaHtml}
          </a>
        </li>
      `;

      if ($beforeNode.length) {
        $beforeNode.before(bannerHtml);
      } else {
        $resultsList.append(bannerHtml);
      }
    });
  })(window.Searchanise.$);
});
